<template>
    <div>
        <div class="p-4">
            <div class="w-full flex flex-row justify-center gap-x-4 pb-2">
                <a v-for="(item, index) in ['Basic', 'Voting', 'AR Image Target']" href="javascript:"
                    class="rounded-3xl border px-4 py-2" :class="tabIndex === index ? 'bg-accent text-white' : ''"
                    :key="index" @click="tabIndex = index">{{
                        item }}</a>
            </div>
            <div v-if="tabIndex === 0">
                <label class="w-full h-80 object-cover bg-secondary mb-3 cursor-pointer flex justify-center items-center"
                    for="banner">
                    <img class="w-full h-80 object-cover bg-secondary" :src="itShowcaseEvent.bannerUrl"
                        v-if="itShowcaseEvent.bannerUrl && itShowcaseEvent.bannerUrl.length > 0" />
                    <div class="text-dark text-xl font-semibold" v-else>Press to upload banner</div>
                </label>
                <input id="banner" type="file" class="hidden" @change="uploadBanner" />
                <InputGroup name="title" class="mb-3" label="Title" v-model="itShowcaseEvent.title" />
                <SelectGroup class="mb-3" name="status" label="Status" v-model="itShowcaseEvent.status"
                    :options="getEventStatuses()" />
                <TextEditorGroup name="description" class="mb-3" label="Description" v-model="itShowcaseEvent.description"
                    :mediaHandler="mediaHandler" />
                <div>
                    <ButtonPrimary @click="save">Save</ButtonPrimary>
                </div>
            </div>
            <div v-else-if="tabIndex === 1">
                <div class="mb-2">
                    <input name="enableVoting" type="checkbox" id="enableVoting" v-model="itShowcaseEvent.enableVoting"
                        :value="true" class="mr-2 text-secondary focus:ring-secondary" />
                    <label class="mr-2" for="enableVoting">Enable Voting</label>
                </div>
                <div class="mb-2" v-if="itShowcaseEvent.enableVoting">
                    <input name="enableLocalStation" type="checkbox" id="enableLocalStation"
                        v-model="itShowcaseEvent.enableLocalStation" :value="true"
                        class="mr-2 text-secondary focus:ring-secondary" />
                    <label class="mr-2" for="enableLocalStation">Vote through local voting station</label>
                </div>
                <div class="mb-2" v-if="itShowcaseEvent.enableLocalStation">
                    <InputGroup name="localVotingStation.code" class="mb-3" label="Local Station Code"
                        v-model="itShowcaseEvent.localVotingStation.code" />
                    <InputGroup name="localVotingStation.password" class="mb-3" label="Local Station Password"
                        v-model="itShowcaseEvent.localVotingStation.password" />
                </div>
            </div>
            <div class="mb-2" v-else-if="tabIndex === 2">
                <div v-if="arImageTargetIndex === -1">
                    <ButtonPrimary class="mb-2" @click="addARImageTarget">Add</ButtonPrimary>
                    <div class="grid sm:grid-cols-4 lg:grid-cols-4 gap-6">
                        <div v-for="(arImageTarget, index) in arImageTargets" :key="index" class="border rounded text-center cursor-pointer relative" >
                            <div class="p-2 h-36" @click="selectARImageTarget(index)">
                                <img class="m-auto max-h-full"
                                :src="arImageTarget.arTargets.length > 0 ? arImageTarget.arTargets[0].targetUrl : null" />
                            </div>
                            
                            <div class="bg-primary text-white rounded-full absolute -top-4 -right-4 w-8 h-8 cursor-pointer flex justify-center items-center" @click="deleteARImageTarget(index)">X</div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <ButtonAccent class="mb-2" @click="arImageTargetIndex = -1">&lessdot;</ButtonAccent>
                    <input id="ar-image-target" ref="arImageTarget" type="file" class="hidden"
                        @change="uploadARImageTarget" />
                    <div class="flex justify-between mb-2">
                        <div>
                            <ButtonPrimary v-if="arTargetIndex > 0" class="mr-2" @click="arTargetIndex--">
                                <ArrowLeftIcon />
                            </ButtonPrimary>
                        </div>
                        <div>
                            <ButtonPrimary @click="selectUpload('arTarget')">
                                <UploadIcon />
                            </ButtonPrimary>
                            <ButtonDanger class="ml-2" v-if="arTargetIndex >= 0" @click="deleteARTarget">
                                <DeleteIcon class="w-6 h-6" />
                            </ButtonDanger>
                            <ButtonPrimary class="ml-2" v-if="arTargetIndex < arImageTarget.arTargets.length - 1"
                                @click="arTargetIndex++">
                                <ArrowRightIcon />
                            </ButtonPrimary>
                        </div>
                    </div>
                    <div v-if="arTargetIndex >= 0 && arImageTarget.arTargets[arTargetIndex]._id" class="flex flex-row justify-between">
                        <div>
                            Status: <span :class="targetStatus === 'Available' ? 'text-green-600' : 'text-red-600'">{{ targetStatus }}</span>
                        </div>
                        <div>
                            Augmentable: <span :class="targetEasyToDetect === 'Easy' ? 'text-green-600' : 'text-red-600'">{{ targetEasyToDetect }}</span>
                        </div>
                    </div>
                    <div class=" bg-secondary mb-2 bg-cover overflow-y-auto" :style="arTargetStyle" style="height: 80vh;">
                        <div class="flex flex-col items-center min-h-full" style="background-color: rgba(0, 0, 0, 0.5)">
                            <div v-for="(arElement, index) in arImageTarget.arElements" :key="index" class="p-2 relative cursor-pointer" @click="selectARElement(index)">
                                <span v-if="arElement.type === 'text'" class="font-bold text-xl text-white">{{
                                    arElement.value || '' }}</span>
                                <img class="max-w-lg" v-else-if="arElement.type === 'photo'"
                                    :src="arElement.value || null" />

                                <div v-if="selectedARElement === index" class="absolute top-0 -right-10 flex flex-col z-50">
                                    <ButtonAccent v-if="index > 0" class="mb-2" @click="moveARElement(index, 'up')"><ArrowUpIcon /></ButtonAccent>
                                    <ButtonAccent v-if="index < arImageTarget.arElements.length - 1" class="mb-2" @click="moveARElement(index, 'down')"><ArrowDownIcon /></ButtonAccent>
                                    <ButtonDanger @click="deleteARElement(index)"><DeleteIcon class="w-6 h-6" /></ButtonDanger>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex justify-between">
                        <div>
                            <ButtonPrimary class="mr-2" @click="textModalVisible = true">
                                <TextIcon />
                            </ButtonPrimary>
                            <ButtonPrimary class="mr-2" @click="selectUpload('arElementPhoto')">
                                <ImageIcon />
                            </ButtonPrimary>
                        </div>
                        <div>
                            <ButtonPrimary @click="settingModalVisible = true">
                                <SettingIcon />
                            </ButtonPrimary>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <TextModal v-if="textModalVisible" :action="insertElement" :closeAction="() => textModalVisible = false" />
        <SettingModal v-if="settingModalVisible" :action="changeSetting" :closeAction="() => settingModalVisible = false"
            :mediaHandler="settingMediaHandler" :arContent="arContent" :arImageTarget="arImageTargets[arImageTargetIndex]" />
    </div>
</template>
<script>
import ITShowcaseEvent from '@/classes/ITShowcaseEvent';
import { useObjectUrl } from '@vueuse/core';
import TextModal from './modals/TextModal';
import SettingModal from './modals/SettingModal';

export default {
    components: {
        TextModal,
        SettingModal,
    },

    data() {
        return {
            itShowcaseEvent: new ITShowcaseEvent(),

            mediaSources: {
                banner: {},
                description: [],
                arImageTargets: {},
                arContent: {},
            },

            tabIndex: 0,
            arImageTargetIndex: -1,
            arTargetIndex: -1,
            selectedARElement: -1,

            arImageTargets: [

            ],
            arImageTargetSelected: '',

            textModalVisible: false,
            settingModalVisible: false,
        };
    },

    async mounted() {
        if (this.$route.params.id !== 'add') {
            this.$root.organizerReadyAction(this.retrieveData);
        }
    },

    methods: {
        async retrieveData() {
            const itShowcaseEvent = await this.$root.organizer.retrieveITShowcaseEvent(this.$route.params.id);
            if (itShowcaseEvent) {
                const arImageTargets = itShowcaseEvent.arImageTargets;
                itShowcaseEvent.setARImageTargets([]);
                this.itShowcaseEvent = itShowcaseEvent;
                this.arImageTargets = arImageTargets;
            }
        },

        mediaHandler(mediaSources = {}) {
            this.mediaSources.description = mediaSources.description;
        },

        async save() {
            const response = await this.$root.organizer.saveITShowcaseEvent(this.itShowcaseEvent, this.mediaSources, this.arImageTargets);
            if (response.result === 'success') {
                this.$router.back();
            }
        },

        uploadBanner(e) {
            const file = e.target.files[0];
            const data = useObjectUrl(file);
            this.mediaSources.banner = {
                url: data.value,
                type: file.type,
                extension: file.name.split('.').pop(),
            };
            this.itShowcaseEvent.bannerUrl = data;
        },

        addARImageTarget() {
            this.arImageTargets.push({
                arTargets: [],
                arElements: [],
                arContent: {
                    type: 'details',
                },
            });

            this.arImageTargetIndex = this.arImageTargets.length - 1;
            this.arTargetIndex = -1;
        },

        selectARImageTarget(index) {
            this.arImageTargetIndex = index;
            this.arTargetIndex = this.arImageTarget.arTargets.length > 0 ? 0 : -1;
        },

        deleteARImageTarget(index) {
            this.arImageTargets.splice(index, 1);
        },

        selectUpload(target) {
            this.arImageTargetSelected = target;
            this.$refs.arImageTarget.click();
        },

        uploadARImageTarget(e) {
            const file = e.target.files[0];
            const data = useObjectUrl(file);
            this.mediaSources.arImageTargets[data.value] = {
                url: data.value,
                type: file.type,
                extension: file.name.split('.').pop(),
            };

            switch (this.arImageTargetSelected) {
                case 'arTarget':
                    {
                        this.arImageTarget.arTargets.push({
                            targetUrl: data.value,
                        });
                        this.arTargetIndex++;
                        break;
                    }

                case 'arElementPhoto':
                    {
                        this.insertElement('photo', data.value);
                        break;
                    }
            }

            this.arImageTargetSelected = '';
            this.$refs.arImageTarget.value = null;
        },

        deleteARTarget() {
            if (this.arTargetIndex >= 0 && this.arTargetIndex < this.arImageTarget.arTargets.length) {
                this.arImageTarget.arTargets.splice(this.arTargetIndex, 1);
                this.arTargetIndex -= 1;

                if (this.arTargetIndex < 0 && this.arImageTarget.arTargets.length > 0) {
                    this.arTargetIndex = 0;
                }
            }
        },

        insertElement(type, value) {
            this.arImageTarget.arElements.push({
                type,
                value,
            });
        },

        changeSetting(arContent) {
            this.arImageTarget.arContent = arContent;
        },

        settingMediaHandler(mediaSources = {}) {
            this.mediaSources.arContent[this.arImageTargetIndex] = mediaSources.description;
        },

        selectARElement(index) {
            if (this.selectedARElement === index) {
                this.selectedARElement = -1;
            } else {
                this.selectedARElement = index;
            }
        },

        moveARElement(index, direction = 'up') {
            const switchIndex = direction === 'up' ? index - 1 : index + 1;
            const temp = this.arImageTarget.arElements[index];
            this.arImageTarget.arElements[index] = this.arImageTarget.arElements[switchIndex];
            this.arImageTarget.arElements[switchIndex] = temp;

            setTimeout(() => this.selectARElement(-1), 300);
        },

        deleteARElement(index) {
            this.arImageTarget.arElements.splice(index, 1);
        },
    },

    watch: {
        'itShowcaseEvent.enableVoting'() {
            if (!this.itShowcaseEvent.enableVoting) {
                this.itShowcaseEvent.setEnableLocalStation(false);
            }
        },

        'itShowcaseEvent.enableLocalStation'() {
            if (!this.itShowcaseEvent.enableLocalStation) {
                this.itShowcaseEvent.setLocalVotingStation({});
            }
        },
    },

    computed: {
        arImageTarget() {
            return this.arImageTargets[this.arImageTargetIndex];
        },

        arTargetStyle() {
            return this.arTargetIndex !== -1 ? `background-image: url(${(this.arImageTarget.arTargets[this.arTargetIndex] || {}).targetUrl});` : '';
        },

        arContent() {
            return this.arImageTarget.arContent;
        },

        targetStatus() {
            const target = this.arImageTarget.arTargets[this.arTargetIndex];
            const display = target.status === 1 ? 'Available' : 'Duplicated';

            return display;
        },

        targetEasyToDetect() {
            const target = this.arImageTarget.arTargets[this.arTargetIndex];
            const display = target.easyToDetect ? 'Easy' : 'Difficult';

            return display;
        }
    },
}
</script>